import { MirrorDetails } from 'store/declarations/declaration';

// Stands in for the DUCR of a B1 that does not have one yet - the BE generates it once the exporter
// EORI on the form is valid. The part is already reserved, so the number is the one the real DUCR
// will end with - see `getMirrorDucr`.
export const getMirrorPendingDucrLabel = (mirrorDetails: MirrorDetails | undefined, messageType: string) => {
    if (!mirrorDetails) return undefined;

    const part = mirrorDetails.ducrPart ?? mirrorDetails.index;

    return `${messageType}/${part} (No DUCR yet)`;
};
